<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">商品管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" label-width="120px" class="user-search">
            <el-form-item label="">
                <el-button size="small" type="primary" @click="addCommodity">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column show-overflow-tooltip prop="id" align="center" label="商品id" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="name" align="center" label="名称" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="buyType" align="center" label="购买方式" >
                <template slot-scope="scope" align="center">
                    <span v-if="scope.row.buyType == 1">现金购买</span>
                    <span v-if="scope.row.buyType == 2">现金+积分</span>
                    <span v-if="scope.row.buyType == 3">纯积分</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="amount" align="center" label="价格" >
                <template slot-scope="scope">
                    <span v-if="scope.row.buyType == 1">{{scope.row.currentPrice}}元</span>
                    <span v-if="scope.row.buyType == 2">{{ scope.row.currentPrice}}元 + {{ scope.row.integral }}积分</span>
                    <span v-if="scope.row.buyType == 3">{{ scope.row.integral }}积分</span>
                </template>
            </el-table-column>
            <el-table-column  prop="orderNum" label="排序" align="center"></el-table-column>
            <el-table-column  prop="inventory" label="库存" align="center" ></el-table-column>
            <el-table-column  prop="status" label="状态" align="center" >
                <template slot-scope="scope">
                    <span v-if="scope.row.status == 1">上架</span>
                    <span v-if="scope.row.status == 0">下架</span>
                </template>
            </el-table-column>
            <el-table-column  prop="createdAt" align="center" label="创建时间" >
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作"> 
                <template slot-scope="scope">
                <el-button size="mini" type="text" v-preventReClick @click="imgListClick(scope.$index, scope.row)">图片管理</el-button>
                <el-button size="mini" type="text" v-preventReClick @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" type="text" v-if="scope.row.status == 0" v-preventReClick @click="operate(scope.row.id , 1)">上架</el-button>
                <el-button size="mini" type="text" v-if="scope.row.status == 1" v-preventReClick @click="operate(scope.row.id , 0)">下架</el-button>
                <el-button size="mini" type="text" v-preventReClick @click="delGoogs(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <!-- 创建 -->
        <el-dialog title="创建商品" :visible.sync="commodityFlag" width="40%" @click="closeDialog">
            <el-form :model="addForm" ref="addForm" label-width="180px" :rules="rules" class="user-search">
                <el-form-item label="商品名称" prop="name">
                    <el-input size="small" style="width:220px" v-model="addForm.name"  placeholder="昵称"></el-input>
                </el-form-item>
                <el-form-item label="图片">
                    <el-upload
                        class="upload-demo"
                        ref="uploadBtn"
                        multiple
                        limit="5"
                        accept=".jpg,.jpeg,.png"
                        :http-request="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :on-exceed="FileExceed"
                        list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                        </el-upload>
                </el-form-item>
                <el-form-item label="商品介绍" prop="description">
                    <quill-editor
                        ref="myQuillEditor"
                        :content="addForm.description"
                        :options="editorOption"
                        @change="onEditorChange($event)"
                    />
                </el-form-item>
                <el-form-item label="成本价" prop="costPrice">
                    <el-input size="small" style="width:220px" v-model="addForm.costPrice"  placeholder="">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="原价" prop="originalPrice">
                    <el-input size="small" style="width:220px" v-model="addForm.originalPrice"  placeholder="">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="购买方式" prop="buyType">
                    <el-radio-group v-model="addForm.buyType" @change="buyTypeChange">
                        <el-radio :label="1">现金购买</el-radio>
                        <el-radio :label="2">现金+积分</el-radio>
                        <el-radio :label="3">纯积分</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="现价">
                    <el-input size="small" v-if="addForm.buyType != 3" style="width:220px" v-model="addForm.currentPrice"  placeholder="">
                        <template slot="append">元</template>
                    </el-input>
                    <span v-if="addForm.buyType == 2"> + </span>
                    <el-input v-if="addForm.buyType != 1" size="small" style="width:220px" v-model="addForm.integral"  placeholder="">
                        <template slot="append">积分</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="是否可参加积分抵现" v-if="addForm.buyType == 1" prop="useIntegral">
                    <el-radio-group v-model="addForm.useIntegral">
                        <el-radio :label="1">参加</el-radio>
                        <el-radio :label="0">不参加</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="积分抵现" prop="useIntegralToMoneyMax" v-if="addForm.useIntegral == 1">
                    <el-input size="small" style="width:350px" v-model="addForm.useIntegralToMoneyMax"  placeholder="">
                        <template slot="prepend">一个订单最多优惠</template>
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="是否可参加支付返积分" v-if="addForm.buyType != 3" prop="giveIntegral">
                    <el-radio-group v-model="addForm.giveIntegral">
                        <el-radio :label="1">参加</el-radio>
                        <el-radio :label="0">不参加</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="返积分" prop="giveIntegralMax" v-if="addForm.giveIntegral == 1">
                    <el-input size="small" style="width:350px" v-model="addForm.giveIntegralMax"  placeholder="">
                        <template slot="prepend">一个订单最多返</template>
                        <template slot="append">积分</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="单人购买次数限制">
                    <el-input size="small" style="width:350px" v-model="addForm.buyTimes"  placeholder="">
                        <template slot="prepend">一个用户最多购买</template>
                        <template slot="append">件</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="规格" prop="standards">
                    <el-input size="small" style="width:220px" v-model="addForm.standards"  placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="库存" prop="inventory">
                    <el-input size="small" style="width:220px" v-model="addForm.inventory"  placeholder="">
                        <template slot="append">件</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="排序" prop="orderNum">
                    <el-input size="small" style="width:220px" v-model="addForm.orderNum"  placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="商品状态" prop="status">
                    <el-radio-group v-model="addForm.status">
                        <el-radio :label="1">上架</el-radio>
                        <el-radio :label="0">下架</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="commodityFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" :disabled="submitFlag" v-preventReClick class="title" @click="addSubmit('addForm')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 编辑 -->
        <el-dialog title="创建商品" :visible.sync="editFlag" width="40%" >
            <el-form :model="editForm" ref="editForm" label-width="180px" :rules="rules" class="user-search">
                <el-form-item label="商品名称" prop="name">
                    <el-input size="small" style="width:220px" v-model="editForm.name"  placeholder="昵称"></el-input>
                </el-form-item>
                <!-- <el-form-item label="图片">
                    <el-upload
                        class="upload-demo"
                        multiple
                        limit="5"
                        accept=".jpg,.jpeg,.png"
                        :http-request="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :on-exceed="FileExceed"
                        list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                </el-form-item> -->
                <el-form-item label="商品介绍" prop="description">
                    <quill-editor
                        ref="myQuillEditor2"
                        :content="editForm.description"
                        :options="editorOption"
                        @change="editFormChange($event)"
                    />
                </el-form-item>
                <el-form-item label="成本价" prop="costPrice">
                    <el-input size="small" style="width:220px" v-model="editForm.costPrice"  placeholder="">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="原价" prop="originalPrice">
                    <el-input size="small" style="width:220px" v-model="editForm.originalPrice"  placeholder="">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="购买方式" prop="buyType">
                    <el-radio-group disabled v-model="editForm.buyType" @change="editBuyTypeChange">
                        <el-radio :label="1">现金购买</el-radio>
                        <el-radio :label="2">现金+积分</el-radio>
                        <el-radio :label="3">纯积分</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="现价">
                    <el-input size="small" v-if="editForm.buyType != 3" style="width:220px" v-model="editForm.currentPrice"  placeholder="">
                        <template slot="append">元</template>
                    </el-input>
                    <span v-if="editForm.buyType == 2"> + </span>
                    <el-input v-if="editForm.buyType != 1" size="small" style="width:220px" v-model="editForm.integral"  placeholder="">
                        <template slot="append">积分</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="是否可参加积分抵现" v-if="editForm.buyType == 1" prop="useIntegral">
                    <el-radio-group v-model="editForm.useIntegral">
                        <el-radio :label="1">参加</el-radio>
                        <el-radio :label="0">不参加</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="积分抵现" prop="useIntegralToMoneyMax" v-if="editForm.useIntegral == 1">
                    <el-input size="small" style="width:350px" v-model="editForm.useIntegralToMoneyMax"  placeholder="">
                        <template slot="prepend">一个订单最多优惠</template>
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="是否可参加支付返积分" v-if="editForm.buyType != 3" prop="giveIntegral">
                    <el-radio-group v-model="editForm.giveIntegral">
                        <el-radio :label="1">参加</el-radio>
                        <el-radio :label="0">不参加</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="返积分" prop="giveIntegralMax" v-if="editForm.giveIntegral == 1">
                    <el-input size="small" style="width:350px" v-model="editForm.giveIntegralMax"  placeholder="">
                        <template slot="prepend">一个订单最多返</template>
                        <template slot="append">积分</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="单人购买次数限制">
                    <el-input size="small" style="width:350px" v-model="editForm.buyTimes"  placeholder="">
                        <template slot="prepend">一个用户最多购买</template>
                        <template slot="append">件</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="规格" prop="standards">
                    <el-input size="small" style="width:220px" v-model="editForm.standards"  placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="库存" prop="inventory">
                    <el-input size="small" style="width:220px" v-model="editForm.inventory"  placeholder="">
                        <template slot="append">件</template>
                    </el-input>
                    <el-button size="small" type="primary" class="title" @click="loadGoodsInventoryRecordList()">
                        查看记录
                    </el-button>
                </el-form-item>
                <el-form-item label="排序" prop="orderNum">
                    <el-input size="small" style="width:220px" v-model="editForm.orderNum"  placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="商品状态" prop="status">
                    <el-radio-group v-model="editForm.status">
                        <el-radio :label="1">上架</el-radio>
                        <el-radio :label="0">下架</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" :disabled="submitFlag" v-preventReClick class="title" @click="editSubmit('editForm')">保存</el-button>
            </div>
        </el-dialog>

        <!-- 库存记录 -->
        <el-dialog title="发货" :visible.sync="RecordListFlag" width="30%">
            <el-table size="small" :data="RecordList" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column show-overflow-tooltip prop="type" label="变动方式" >
                    <template slot-scope="scope" align="center">
                        <span v-if="scope.row.type == 1">增加</span>
                        <span v-if="scope.row.type == 2">减少</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="num" label="数量" ></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="RecordListFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 图片管理 -->
        <el-dialog title="图片管理" :visible.sync="imgListFlag" width="40%">
            <el-button size="small" type="primary" v-preventReClick class="title" @click="uploadClick()">上传图片</el-button>
            <el-table size="small" :data="imgList" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                <el-table-column prop="type" label="图片" >
                    <template slot-scope="scope" align="center">
                        <el-image
                        style="width: 200px; height: 100px"
                        class="img_inner"
                        :src="scope.row.file"
                        fit="fit"></el-image>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="orderNum" label="排序" ></el-table-column>
                <el-table-column align="center" label="操作"> 
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" v-if="scope.$index != 0" v-preventReClick @click="sortClick(scope.row , scope.$index , 'top')">上移</el-button>
                        <el-button size="mini" type="text" v-if="scope.$index != (imgList.length-1)" v-preventReClick @click="sortClick(scope.row , scope.$index , 'bottom')">下移</el-button>
                        <el-button size="mini" type="text" v-preventReClick @click="delImg(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="imgListFlag = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 上传图片 -->
        <el-dialog title="上传图片" :visible.sync="uploadFlag" width="25%">
            <el-upload
                class="upload-demo"
                multiple
                :limit="uploadNum"
                ref="uploadBtn"
                accept=".jpg,.jpeg,.png"
                :http-request="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-exceed="FileExceed"
                list-type="picture">
                <el-button size="small" type="primary">点击上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            </el-upload>    
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="uploadFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" :disabled="submitFlag" v-preventReClick class="title" @click="uploadSubmit('addForm')">保存</el-button>
            </div>
        </el-dialog>

        <el-upload
            v-show="false"
            class="avatar-uploader"
            :data='fileUpload'
            :show-file-list="false"
            :http-request="onUploadHandler"
            >
        </el-upload>

</div>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Pagination from '../../../components/Pagination'
import { loadGoodsList , updateGoodsStatus , loadGoodsInventoryRecordList,
    loadGoodsFileList ,deleteGoodsFile , changeFileSort , deleteGoods } from '../../../api/userMG'
export default {
    data(){
        return{
            editorOption: {
                modules: {
                toolbar: {
                    container: [
                    ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
                    [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
                    [{ indent: '-1' }, { indent: '+1' }], // 缩进
                    [{ direction: 'rtl' }], // 文本方向
                    // [{ font: ['songti'] }], // 字体种类
                    ['clean'], // 清除文本格式
                    ['image'] // 链接、图片、视频
                    ],
                    handlers: {
                        'image': function (value) {
                            if (value) { // value === true
                                document.querySelector('.avatar-uploader input').click()
                            } else {
                                this.quill.format('image', false)
                            }
                        }
                    }
                }
                },
                placeholder: '请输入正文'
            },
            goodsId:'',
            uploadNum:0,
            uploadFlag:false,
            imgListFlag:false,
            imgList:[],
            RecordListFlag:false,
            RecordList:[],
            editFlag:false,
            content:'',
            fileList:[],
            commodityFlag:false,
            bindingFlag:false,
            activeName:"information",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
            },
            machineData:[],
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            addForm:{
                name:'',
                costPrice:'',
                originalPrice:'',
                currentPrice:'',
                integral:'',
                buyType:1,
                useIntegral:0,
                useIntegralToMoneyMax:'',
                giveIntegral:0,
                giveIntegralMax:'',
                buyTimes:'',
                standards:'',
                inventory:'',
                description:'',
                status:1,
                orderNum:''
            },
            rules: {
                costPrice: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { message: '格式错误（小数点保留两位）', trigger: 'blur' , pattern:/^[0-9]+(.[0-9]{2})?$/ }
                ],
                originalPrice: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { message: '格式错误（小数点保留两位）', trigger: 'blur' , pattern:/^[0-9]+(.[0-9]{2})?$/ }
                ],
                useIntegralToMoneyMax: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { message: '格式错误（小数点保留两位）', trigger: 'blur' , pattern:/^[0-9]+(.[0-9]{2})?$/ }
                ],
                giveIntegralMax:[
                    { required: true, message: '请输入', trigger: 'blur' },
                    { message: '格式错误',trigger: 'blur', pattern:/^[0-9]*$/}
                ],
                buyTimes:[
                    { required: true, message: '请输入', trigger: 'blur' },
                    { message: '格式错误',trigger: 'blur', pattern:/^[0-9]*$/}
                ],
                orderNum:[
                    { required: true, message: '请输入', trigger: 'blur' },
                    { message: '格式错误',trigger: 'blur', pattern:/^[0-9]*$/}
                ],
                inventory:[
                    { required: true, message: '请输入', trigger: 'blur' },
                    { message: '格式错误',trigger: 'blur', pattern:/^[0-9]*$/}
                ],
                name: [
                { required: true, message: '请输入', trigger: 'blur' , trigger: 'change' }
                ],
                standards: [
                { required: true, message: '请输入', trigger: 'blur' , trigger: 'change' }
                ],
                description: [
                { required: true, message: '请输入', trigger: 'blur' , trigger: 'change' }
                ],
            },
        }
    },
    components: {
        Pagination,
        quillEditor
    },
    created(){
        this.getdata()
    },
    methods:{
        async onUploadHandler(file) {
            let formData = new FormData()
            formData.append('file' ,file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                // 获取光标所在位置
                if(this.editFlag == true){
                    let quill = this.$refs.myQuillEditor2.quill
                    let length = quill.getSelection().index
                    // 插入图片
                    quill.insertEmbed(length, 'image', res.data.data)
                    // 调整光标到最后
                    quill.setSelection(length + 1)
                }else {
                    let quill = this.$refs.myQuillEditor.quill
                    let length = quill.getSelection().index
                    // 插入图片
                    quill.insertEmbed(length, 'image', res.data.data)
                    // 调整光标到最后
                    quill.setSelection(length + 1)
                }
                
            })
        },
        editBuyTypeChange(){
            this.editForm.useIntegral = 0
            this.editForm.giveIntegral = 0
        },
        buyTypeChange(){
            this.addForm.useIntegral = 0
            this.addForm.giveIntegral = 0
        },
        sortClick(row , index , type){
            let associationId = ''
            if(type == 'top'){
                associationId = this.imgList[index - 1].id
            }else if(type == 'bottom') {
                associationId = this.imgList[index + 1].id
            }
            changeFileSort({
                id:row.id,
                associationId:associationId
            }).then(res=>{
                if(res.success){
                    this.$message.success('操作成功')
                    this.imgList = res.fileList
                }
            })
        },
        delGoogs(row){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteGoods({id:row.id}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        delImg(row){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteGoodsFile({id:row.id}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.imgListClick(1 , {id:this.goodsId})
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        uploadSubmit(){
            if(this.fileList.length == 0)return
            let formData = new FormData()
            for(let item of this.fileList){
                formData.append('uplaodFile' , item)
            }
            formData.append('goodsId ' , this.goodsId)
            formData.append('orderNum ' , this.orderNum)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/goods/uploadGoodsFile",
                headers: {
                "Content-Type": "multipart/form-data",
                token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                console.log(res)
                if(res.data.success == true){
                    this.$message.success('上传成功')
                    this.uploadFlag = false
                    this.imgListClick(1 , {id:this.goodsId})
                    this.$refs.uploadBtn.clearFiles()
                    this.fileList = []
                }else {
                    this.$message.error(res.data.messages)
                }
                
            })
        },
        uploadClick(){
            if((5 - this.imgList.length) == 0){
                this.$message.error('图片最多可上传五张')
            }else {
                this.uploadNum = 5 - this.imgList.length
                this.uploadFlag = true
            }
            if(this.imgList.length != 0){
                this.orderNum = this.imgList[this.imgList.length-1].orderNum
            }else {
                this.orderNum = 0
            }
        },
        imgListClick(index , row){
            console.log(row)
            this.goodsId = row.id
            loadGoodsFileList({
                goodsId:row.id
            }).then(res=>{
                this.imgListFlag = true
                this.imgList = res.fileList
            })
        },
        loadGoodsInventoryRecordList(){
            loadGoodsInventoryRecordList({
                goodsId:this.editForm.id
            }).then(res=>{
                this.RecordList = res.recordList
                this.RecordListFlag = true
            })
        },
        operate(id , status){
            updateGoodsStatus({
                id:id,
                status:status
            }).then(res=>{
                if(res.success){
                    this.$message.success("操作成功")
                    this.getdata()
                }else{
                    this.$message.error(res.messages)
                }
            })
        },  
        onEditorChange({ quill, html, text }) {
            this.addForm.description = html
        },
        editFormChange({ quill, html, text }) {
            this.editForm.description = html
        },
        editSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    if(this.editForm.buyType == 1 && this.editForm.currentPrice == ''){
                        this.$message.error('请输入现价金额')
                    }else if(this.editForm.buyType == 2 && this.editForm.currentPrice == '' && this.editForm.integral == ''){
                        this.$message.error('请输入现价金额和积分')
                    }else if(this.editForm.buyType == 3 && this.editForm.integral == ''){
                        this.$message.error('请输入积分')
                    }else{
                        console.log(this.editForm)
                        let data = this.editForm
                        let formData = new FormData()
                        for(let item of this.fileList){
                            formData.append('uplaodFile' , item)
                        }
                        formData.append('name' , data.name)
                        formData.append('costPrice' , data.costPrice)
                        formData.append('originalPrice' , data.originalPrice)
                        formData.append('currentPrice' , data.currentPrice)
                        formData.append('integral' , data.integral == undefined?'':data.integral)
                        formData.append('buyType' , data.buyType)
                        formData.append('useIntegral' , data.useIntegral)
                        formData.append('useIntegralToMoneyMax' , data.useIntegralToMoneyMax == undefined?'':data.useIntegralToMoneyMax)
                        formData.append('giveIntegral' , data.giveIntegral)
                        formData.append('giveIntegralMax' , data.giveIntegralMax)
                        formData.append('buyTimes' , data.buyTimes == undefined?'':data.buyTimes)
                        formData.append('standards' , data.standards)
                        formData.append('inventory' , data.inventory)
                        formData.append('description' , data.description.replace(/img/g,`img style="width:100%"`))
                        formData.append('status' , data.status)
                        formData.append('orderNum' , data.orderNum)
                        formData.append('id' , data.id)
                        this.$axios({
                            method: "POST",
                            url: "/yunyue-houtai/goods/saveOrUpdateGoods",
                            headers: {
                            "Content-Type": "multipart/form-data",
                            token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                            },
                            data: formData,
                        }).then(res=>{
                            console.log(res)
                            if(res.data.success == true){
                                this.$message.success('修改成功')
                                this.editFlag = false
                                this.getdata()
                                this.editForm = {
                                    
                                }
                                this.fileList = []
                            }else {
                                this.$message.error(res.data.messages)
                            }
                            
                        })
                    }
                } else {
                    return false
                }
            })
        },
        addSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    if(this.addForm.buyType == 1 && this.addForm.currentPrice == ''){
                        this.$message.error('请输入现价金额')
                    }else if(this.addForm.buyType == 2 && this.addForm.currentPrice == '' && this.addForm.integral == ''){
                        this.$message.error('请输入现价金额和积分')
                    }else if(this.addForm.buyType == 3 && this.addForm.integral == ''){
                        this.$message.error('请输入积分')
                    }else if(this.fileList.length == 0){
                        this.$message.error('请上传图片')
                    }else{
                        console.log(this.addForm)
                        let data = this.addForm
                        let formData = new FormData()
                        for(let item of this.fileList){
                            formData.append('uplaodFile' , item)
                        }
                        formData.append('name' , data.name)
                        formData.append('costPrice' , data.costPrice)
                        formData.append('originalPrice' , data.originalPrice)
                        formData.append('currentPrice' , data.currentPrice)
                        formData.append('integral' , data.integral)
                        formData.append('buyType' , data.buyType)
                        formData.append('useIntegral' , data.useIntegral)
                        formData.append('useIntegralToMoneyMax' , data.useIntegralToMoneyMax)
                        formData.append('giveIntegral' , data.giveIntegral)
                        formData.append('giveIntegralMax' , data.giveIntegralMax)
                        formData.append('buyTimes' , data.buyTimes)
                        formData.append('standards' , data.standards)
                        formData.append('inventory' , data.inventory)
                        formData.append('description' , data.description.replace(/img/g,`img style="width:100%"`))
                        formData.append('status' , data.status)
                        formData.append('orderNum' , data.orderNum)
                        this.$axios({
                            method: "POST",
                            url: "/yunyue-houtai/goods/saveOrUpdateGoods",
                            headers: {
                            "Content-Type": "multipart/form-data",
                            token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                            },
                            data: formData,
                        }).then(res=>{
                            console.log(res)
                            if(res.data.success == true){
                                this.$message.success('创建成功')
                                this.commodityFlag = false
                                this.getdata()
                                this.addForm = {
                                    name:'',
                                    costPrice:'',
                                    originalPrice:'',
                                    currentPrice:'',
                                    integral:'',
                                    buyType:1,
                                    useIntegral:0,
                                    useIntegralToMoneyMax:'',
                                    giveIntegral:0,
                                    giveIntegralMax:'',
                                    buyTimes:'',
                                    standards:'',
                                    inventory:'',
                                    description:'',
                                    status:1,
                                    orderNum:1
                                }
                                this.fileList = []
                            }else {
                                this.$message.error(res.data.messages)
                            }
                            
                        })
                    }
                } else {
                    return false
                }
            })
        }, 
        FileExceed(file){
            console.log(file)
            this.$message.error(`图片最多可上传${this.uploadNum}张`)
        },
        handlePictureCardPreview(file , fileList) {
            console.log(file)
            console.log(fileList)
            this.fileList.push(file.file)
        },
        handleRemove(file , fileList){
            console.log(file)
            console.log(fileList)
            let data = []
            for(let item of fileList){
                data.push(item.raw)
            }
            this.fileList = data
        },
        addCommodity(){
            this.commodityFlag = true
            this.$refs.uploadBtn.clearFiles()
            this.fileList = []
            this.uploadNum = 5
        },
        handleEdit(index , row){
            this.editFlag = true
            this.editForm = JSON.parse(JSON.stringify(row))
        },
        addClick(){
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            loadGoodsList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
            }).then(res=>{
                this.listData = res.pageInfo.list
                this.pageparm.total = res.pageInfo.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
.el-form-item__content {
    line-height: 35px;
    position: relative;
    font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/views/shoppingMall/commodity/commodityList.vue